import { z } from "zod";

// Colors should be in full hex notation with the leading # (e.g., "#BEFA00")
export const RoamThemeOverrides = z.object({
  accentColor: z.string().length(7).optional(),
  backgroundVisualizationColor: z.string().length(7).optional(),
});
export type RoamThemeOverrides = z.infer<typeof RoamThemeOverrides>;
